import * as React from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ExternalUrlGroupsSectionType } from '../metroline/types';
import { ExternalUrlGroupsFormProps } from '../types';
import { ExternalUrlGroupsContainer } from './external-url-group-container';
import { DetailsContainer } from './external-url-group-details';
import { ExternalUrlGroupsLanguage } from './external-url-group-language';
import { ExternalUrlContainer } from 'app/area/external-url-groups/form/components/external-url-container';
import { AccessPolicyContainer } from 'app/area/external-url-groups/form/components/access-policy-container';
import { getTextInLanguage } from 'app/components/translation/translations/get-text-in-language';

const ExternalUrlGroupsFormRendererContainer: React.FC<ExternalUrlGroupsFormProps
  & WithMetroLineWrappedComponentProps<ExternalUrlGroupsSectionType>> = ({
    locale, translation, section, translationAdminAccess, externalUrlAccess, options, shouldPrompt, externalUrlOptions,
    actionType, formState, mainLanguage, showTranslations, accessPolicyValidation, externalUrlsValidation,
    switchTranslationsToggle, saveExternalUrlGroup, deleteExternalUrlGroup, updateItem,
    changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
    loadOptions, loadExternalUrlOptions, updateValidation, displayError, getRef, shouldRenderSection,
    updateAccessPolicyItem, removeAccessPolicy, addAccessPolicy,
    resetAccessPolicyClientValidation, resetAccessPolicyServerValidation, removeAllAccessPolicy,
    updateExternalUrl, addExternalUrls, deleteExternalUrl, deleteAllExternalUrls
  }) => {

    const {
      externalUrlGroupItem, languageOptions, validation, fetchingAddExternalUrls
    } = formState;

    const panelProps = {
      actionType,
      externalUrlGroupItem,
      externalUrlOptions,
      options,
      locale,
      validation,
      translation,
      section,
      translationAdminAccess,
      externalUrlAccess,
      accessPolicyValidation,
      updateAccessPolicyItem,
      removeAccessPolicy,
      addAccessPolicy,
      resetAccessPolicyClientValidation,
      resetAccessPolicyServerValidation,
      removeAllAccessPolicy,
      getRef,
      shouldRenderSection,
      loadOptions,
      loadExternalUrlOptions,
      updateItem,
      updateValidation,
      displayError
    };

    const languageDescription = getTextInLanguage(externalUrlGroupItem?.language, mainLanguage)?.description;
    const languageLongDescription = getTextInLanguage(externalUrlGroupItem?.longDescription, mainLanguage)?.description;

    const renderLanguageOnTop = !isDefinedIncludingZero(externalUrlGroupItem?.id);
    const languageSection = <ExternalUrlGroupsLanguage
      language={externalUrlGroupItem?.language}
      longDescription={externalUrlGroupItem?.longDescription}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      changeLongDescription={changeLongDescription}
      copyLongDescriptionToAll={copyLongDescriptionToAll}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    return <ExternalUrlGroupsContainer
      actionType={actionType}
      externalUrls={externalUrlGroupItem.externalUrls}
      description={languageDescription}
      longDescription={languageLongDescription}
      formState={formState}
      shouldPrompt={shouldPrompt}
      mainLanguage={mainLanguage}
      switchTranslationsToggle={switchTranslationsToggle}
      saveExternalUrlGroup={saveExternalUrlGroup}
      deleteExternalUrlGroup={deleteExternalUrlGroup}
      updateValidation={updateValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}>
      {renderLanguageOnTop && languageSection}
      <DetailsContainer {...panelProps} />
      <AccessPolicyContainer {...panelProps} />
      <ExternalUrlContainer
        externalUrls={externalUrlGroupItem.externalUrls}
        updateValidation={undefined}
        addExternalUrls={addExternalUrls}
        updateExternalUrl={updateExternalUrl}
        deleteExternalUrl={deleteExternalUrl}
        deleteAllExternalUrls={deleteAllExternalUrls}
        fetchingAddExternalUrls={fetchingAddExternalUrls}
        displayError={displayError}
        externalUrlOptions={externalUrlOptions}
        loadExternalUrlOptions={loadExternalUrlOptions}
        locale={locale}
        externalUrlsValidation={externalUrlsValidation}
        translation={translation}
        section={section}
        getRef={getRef}
        shouldRenderSection={shouldRenderSection} />
      {!renderLanguageOnTop && languageSection}
    </ExternalUrlGroupsContainer>;
  };

export const ExternalUrlGroupsFormRenderer = withMetroLine<ExternalUrlGroupsFormProps,
  ExternalUrlGroupsSectionType>()(ExternalUrlGroupsFormRendererContainer);
